import { render, staticRenderFns } from "./CName.vue?vue&type=template&id=bf3fde5c&scoped=true&"
import script from "./CName.vue?vue&type=script&lang=js&"
export * from "./CName.vue?vue&type=script&lang=js&"
import style0 from "./CName.vue?vue&type=style&index=0&id=bf3fde5c&prod&scoped=true&lang=css&"
import style1 from "@assets/css/phone_email_icon.css?vue&type=style&index=1&id=bf3fde5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3fde5c",
  null
  
)

export default component.exports